import _typeof from '@babel/runtime/helpers/typeof';

// can be any style string, but also a keyword mapping to a theme value
var resolveThemeKeyword = function resolveThemeKeyword(style, theme) {
  if (style === 'primary') {
    return theme.colors.primary;
  } else if (style === 'secondary') {
    return theme.colors.secondary;
  } else if (style === 'alert') {
    return theme.colors.alert;
  } else if (style === 'text') {
    return theme.colors.text;
  } else if (style === 'background') {
    return theme.colors.background;
  } else if (style === 'borders.radius') {
    return theme.borders.radius || '0px';
  }

  return style;
};
var themeResolver = function themeResolver(inputTheme) {
  var _theme$variant;

  // deep clone
  var theme = JSON.parse(JSON.stringify(inputTheme));
  theme.variant = (_theme$variant = theme.variant) !== null && _theme$variant !== void 0 ? _theme$variant : 'normal'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

  var recurse = function recurse(obj) {
    for (var key in obj) {
      var value = obj[key];

      if (value != undefined) {
        if (value && _typeof(value) === 'object') {
          recurse(value);
        } else {
          obj[key] = resolveThemeKeyword(value, theme);
        }
      }
    }
  };

  recurse(theme);
  return theme;
};

export { resolveThemeKeyword, themeResolver };
